module.exports = __webpack_public_path__ + "img/questionEmpty.aaf8d7a7.png";